export * from './externals';

export const ROOT_DOMAIN_NAME = 'ads';

export const UID_POLL_INTERVAL_DEFAULT_MS = 20000;

export const DISPLAY_AD_ZONES = Object.freeze({
  NOW_PLAYING: 'NOW_PLAYING',
  BACKSTAGE: 'BACKSTAGE',
} as const);

export const REWARD_URLS = Object.freeze({
  FLEX_REPLAY: 'FLEX_REPLAY',
  FLEX_SKIP: 'FLEX_SKIP',
  FLEX_THUMBS_DOWN: 'FLEX_THUMBS_DOWN',
  SLOPA: 'SLOPA',
  SLOPA_NO_AVAILS: 'SLOPA_NO_AVAILS',
} as const);

/**
 *
 * onetrust ads cookies group is C0002, it is used to check if user has consented to this
 * https://my.onetrust.com/s/article/UUID-301b21c8-a73a-05e8-175a-36c9036728dc?language=en_US
 */
export const ONETRUST_COOKIE_GROUP = Object.freeze({
  AD_GROUP: 'C0002',
});
